import React, { Component } from "react";
import {Panel} from 'react-bootstrap';

import { Table, Form, FormGroup, Glyphicon, Col, ControlLabel, OverlayTrigger} from 'react-bootstrap';
import {tooltip} from '../Utils';

//Services
import {ReasonService} from '../Services/ReasonService';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { REASON_TYPE } from "../Constants";


const styles = theme => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    textField: {
        width: 200,
        margin: 0,
        marginTop: 10,
        height: 50
    },
  });

class ManageReason extends Component {

    constructor(props) {
        super(props);

        this.state = {
            udReasons: [],
            udReasonsUI: [],
            udmodal: { type: '', reason: ''},
            rqReasons: [],
            rqReasonsUI: [],
            rqmodal: { type: '', reason: ''},
            iqReasons: [],
            iqReasonsUI: [],
            iqmodal: { type: '', reason: ''},
            cnReasons: [],
            cnReasonsUI: [],
            cnmodal: { type: '', reason: ''},
        };
        this.handleChange = this.handleChange.bind(this);
        this.saveReason = this.saveReason.bind(this);
        this.removeReason = this.removeReason.bind(this);
        this.getValidationStateReason = this.getValidationStateReason.bind(this);
    }

    componentDidMount(){
        this.props.setTitle('Manage Reasons');
        this.fetchReason(REASON_TYPE.UNDELIVERABLE);
        this.fetchReason(REASON_TYPE.REDUCING_QTY);
        this.fetchReason(REASON_TYPE.INCREASING_QTY);
        this.fetchReason(REASON_TYPE.CREDITNOTE);
    }

    fetchReason(type){
        ReasonService.getReasonByType(type)
        .then((data) => {
            console.log(data);
            let list = [];
            data.reasons.forEach((element, index) => {
                list.push(<ReasonDetails key={index} item={element} removeReason={this.removeReason}/>);
            });
            switch(type){
                case REASON_TYPE.UNDELIVERABLE:
                    this.setState({udReasons: data.reasons, udReasonsUI: list});
                    break;
                case REASON_TYPE.REDUCING_QTY:
                    this.setState({rqReasons: data.reasons, rqReasonsUI: list});
                    break;
                case REASON_TYPE.INCREASING_QTY:
                    this.setState({iqReasons: data.reasons, iqReasonsUI: list});
                    break;
                case REASON_TYPE.CREDITNOTE:
                    this.setState({cnReasons: data.reasons, cnReasonsUI: list});
                    break;
                default:
            }
            
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChange(e, type) {
        e.preventDefault();
        let change = {};
        switch(type){
            case REASON_TYPE.UNDELIVERABLE:
                change = this.state.udmodal;
                change[e.target.name] = e.target.value;
                this.setState({udmodal: change});
                break;
            case REASON_TYPE.REDUCING_QTY:
                change = this.state.rqmodal;
                change[e.target.name] = e.target.value;
                this.setState({rqmodal: change});
                break;
            case REASON_TYPE.INCREASING_QTY:
                change = this.state.iqmodal;
                change[e.target.name] = e.target.value;
                this.setState({iqmodal: change});
                break;
            case REASON_TYPE.CREDITNOTE:
                change = this.state.cnmodal;
                change[e.target.name] = e.target.value;
                this.setState({cnmodal: change});
                break;
            default:
        }
    }

    removeReason(e, type, reason){
        e.preventDefault();
        if(type && reason) {
            this.setState({toRemove : { type: type, reason : reason }});
            this.props.showConfirmDialog("This will not effect the existing delivery information.", "Confirm removal of Reason?", this.proceed);
        }
    }

    proceed = () => {
        let {type, reason} = this.state.toRemove; 
        ReasonService.removeReason(type, reason)
        .then(() =>{
            this.fetchReason(type);
            this.setState({toRemove: {}});
            this.props.closeConfirmDialog();
            this.props.showSnackBar(`Removed Reason ${reason}`, 'success');
        })
        .catch((error) => {
            this.props.showSnackBar(`Failed to remove Reason ${reason}. Please try again.`, 'error');
        });
    }

    saveReason(e, type){
        console.log(type);
        e.preventDefault();
        let modal = {};
        switch(type){
            case REASON_TYPE.UNDELIVERABLE:
                modal = this.state.udmodal;
                break;
            case REASON_TYPE.REDUCING_QTY:
                modal = this.state.rqmodal;
                break;
            case REASON_TYPE.INCREASING_QTY:
                modal = this.state.iqmodal;
                break;
            case REASON_TYPE.CREDITNOTE:
                modal = this.state.cnmodal;
                break;
            default:
        }
        
        if(modal.reason.length > 0 && this.alreadyExists(type, modal.reason).length === 0){
            ReasonService.createReason(type, modal.reason)
            .then(() => {
                this.fetchReason(type);
                this.setState({udmodal: { type: '', reason: ''}, rqmodal: { type: '', reason: ''}, iqmodal: { type: '', reason: ''}});
            })
            .catch((error) => {
                this.props.showSnackBar(`Failed to create Reason ${modal.reason}. Please try again.`, 'error');
            });
        } else {
            this.props.showSnackBar(`${modal.reason} already exists.`, 'error');
        }
    }

    alreadyExists(type, reason){
        let list;
        switch(type){
            case REASON_TYPE.UNDELIVERABLE:
                list = this.state.udReasons;
                break;
            case REASON_TYPE.REDUCING_QTY:
                list = this.state.rqReasons;
                break;
            case REASON_TYPE.INCREASING_QTY:
                list = this.state.iqReasons;
                break;
            case REASON_TYPE.CREDITNOTE:
                list = this.state.cnReasons;
                break;
            default:
                list = [];
        }
        return list.filter((item) => item.reason === reason);
    }

    render() {
        return ( 
            <div className="Home" style={{marginTop: 32}}>
                
                {/* Undeliverable Reasons */}
                {this.reasonBlock("Undeliverable Reasons", this.saveReason, REASON_TYPE.UNDELIVERABLE ,this.state.udReasonsUI, this.state.udmodal)}

                {/* Reducing Qty Reasons */}
                {this.reasonBlock("Reducing Quantity during deliveries", this.saveReason, REASON_TYPE.REDUCING_QTY ,this.state.rqReasonsUI, this.state.rqmodal)}

                {/* Increasing Qty Reasons */}
                {this.reasonBlock("Increasing Quantity during deliveries", this.saveReason, REASON_TYPE.INCREASING_QTY ,this.state.iqReasonsUI, this.state.iqmodal)}

                {/* Credit Note Reasons */}
                {this.reasonBlock("Credit Note Reasons", this.saveReason, REASON_TYPE.CREDITNOTE ,this.state.cnReasonsUI, this.state.cnmodal, 30)}
                
            </div>
        );
    }

    getValidationStateReason(type){
        let modal = {};
        switch(type){
            case REASON_TYPE.UNDELIVERABLE:
                modal = this.state.udmodal;
                break;
            case REASON_TYPE.REDUCING_QTY:
                modal = this.state.rqmodal;
                break;
            case REASON_TYPE.INCREASING_QTY:
                modal = this.state.iqmodal;
                break;
            case REASON_TYPE.CREDITNOTE:
                modal = this.state.cnmodal;
                break;
            default:
        }
        if(modal.reason){
            const length = modal.reason.length;
            if (length > 1 && this.alreadyExists(type, modal.reason).length === 0) return 'success';
            else return 'warning';
        }
        return null;
        
    }

    reasonBlock = (title, submitFunction, type, list, modal, charLimit = 100) => (
                    <ExpansionPanel style={{"maxWidth": "100%"}}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={this.props.classes.heading}>{title}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography  style={{width: "100%"}}>
                                <Panel>
                                    <Panel.Body style={{backgroundColor: "white"}}>
                                        <Col xs={6} md={6}>
                                            <Form inline onSubmit={(e)=> submitFunction(e, type)}>
                                                <FormGroup  validationState={this.getValidationStateReason(type)}>
                                                    <Col componentClass={ControlLabel} sm={2} style={{paddingTop: "5px", marginTop: '20px'}}>
                                                        Reason
                                                    </Col>
                                                    <Col sm={6}>
                                                        <TextField
                                                            id="reason"
                                                            className={this.props.classes.textField}
                                                            variant="outlined"
                                                            label="Reason"
                                                            margin="normal"
                                                            value={modal.reason}
                                                            name="reason"
                                                            onChange={(e) => this.handleChange(e, type)}
                                                            type="text"
                                                            InputProps={{
                                                                inputProps: {
                                                                    maxLength: charLimit
                                                                }
                                                            }}
                                                            required />
                                                    </Col>
                                                    <Col sm={3}>
                                                        <Button type="submit" variant="outlined" size="medium" color="primary" style={{marginTop: '20px'}} onClick={(e)=> submitFunction(e, type)}>Save</Button>
                                                    </Col>
                                                </FormGroup>
                                            </Form>
                                        </Col>
                                        <Col xs={6} md={4}>
                                            <Table striped condensed hover responsive>
                                                <thead>
                                                    <tr>
                                                        <th>Reason</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Panel.Body>
                                </Panel>
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
    )
}

class ReasonDetails extends Component {

    render() {
        const item = this.props.item;
        
        return (
                <tr>
                    <td>{item.reason}</td>
                    <td>
                        <OverlayTrigger placement="bottom" overlay={tooltip("Remove Agent")}>
                            <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.removeReason(e, item.type, item.reason)}/>
                        </OverlayTrigger>
                    </td>
                </tr>
        );
    }
}

export default withStyles(styles)(ManageReason);